import {
  GET_CHITIET_HOPDONG,
  GET_CHITIET_HOPDONG_SUCCESS,
  GET_CHITIET_HOPDONG_FAILURE,
  GET_LICH_SU_HOP_DONG,
  GET_LICH_SU_HOP_DONG_SUCCESS,
  GET_LICH_SU_HOP_DONG_FAILURE,
  GET_LICH_SU_VT_TB,
  GET_LICH_SU_VT_TB_SUCCESS,
  GET_LICH_SU_VT_TB_FAILURE,
  GET_LIST_TAI_SAN_CAM_CO,
  GET_LIST_TAI_SAN_CAM_CO_SUCCESS,
  GET_LIST_TAI_SAN_CAM_CO_FAILURE,
  GET_LICH_SU_NO_PHAI_THU,
  GET_LICH_SU_NO_PHAI_THU_SUCCESS,
  GET_LICH_SU_NO_PHAI_THU_FAILURE,
  GET_LIST_GHI_CHU,
  GET_LIST_GHI_CHU_SUCCESS,
  GET_LIST_GHI_CHU_FAILURE,
} from "./actionTypes";

export const getChiTietHopDong = (dataSearch) => ({
  type: GET_CHITIET_HOPDONG,
  dataSearch,
});

export const getChiTietHopDongSuccess = (data) => ({
  type: GET_CHITIET_HOPDONG_SUCCESS,
  payload: data,
});

export const getChiTietHopDongFailure = () => ({
  type: GET_CHITIET_HOPDONG_FAILURE,
});

export const getLichSuHopDong = (dataSearch) => ({
  type: GET_LICH_SU_HOP_DONG,
  dataSearch,
});

export const getLichSuHopDongSuccess = (data) => ({
  type: GET_LICH_SU_HOP_DONG_SUCCESS,
  payload: data,
});

export const getLichSuHopDongFailure = () => ({
  type: GET_LICH_SU_HOP_DONG_FAILURE,
});

export const getLichSuVayThemTraBotGoc = (dataSearch) => ({
  type: GET_LICH_SU_VT_TB,
  dataSearch,
});

export const getLichSuVayThemTraBotGocSuccess = (data) => ({
  type: GET_LICH_SU_VT_TB_SUCCESS,
  payload: data,
});

export const getLichSuVayThemTraBotGocFailure = () => ({
  type: GET_LICH_SU_VT_TB_FAILURE,
});

export const getListTaiSanCamCo = (dataSearch) => ({
  type: GET_LIST_TAI_SAN_CAM_CO,
  dataSearch,
});

export const getListTaiSanCamCoSuccess = (data) => ({
  type: GET_LIST_TAI_SAN_CAM_CO_SUCCESS,
  payload: data,
});

export const getListTaiSanCamCoFailure = () => ({
  type: GET_LIST_TAI_SAN_CAM_CO_FAILURE,
});

export const getLichSuNoPhaiThu = (dataSearch) => ({
  type: GET_LICH_SU_NO_PHAI_THU,
  dataSearch,
});

export const getLichSuNoPhaiThuSuccess = (data) => ({
  type: GET_LICH_SU_NO_PHAI_THU_SUCCESS,
  payload: data,
});

export const getLichSuNoPhaiThuFailure = () => ({
  type: GET_LICH_SU_NO_PHAI_THU_FAILURE,
});

export const getListGhiChu = (dataSearch) => ({
  type: GET_LIST_GHI_CHU,
  dataSearch,
});

export const getListGhiChuSuccess = (data) => ({
  type: GET_LIST_GHI_CHU_SUCCESS,
  payload: data,
});

export const getListGhiChuFailure = () => ({
  type: GET_LIST_GHI_CHU_FAILURE,
});
